// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__xyj2q","large":"styles_large__1h2ls"};